<template>
  <div class="content">
    <base-header class="pb-6 bg-default">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="12">
          <h1 class="h2 text-white d-inline-block mb-0">
            Liste des exportations de produits
          </h1>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <RouteBreadcrumb />
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <BaseTableSearch
        :data="exports"
        placeholder="Num. de commande, num. de membre, adresse courriel ou nom du client"
      >
        <template #header>
          <b-row slot="header" align-v="center">
            <b-col sm="3">
              <h3 class="mb-0">Exportations</h3>
            </b-col>
            <b-col sm="9" class="text-right">
              <BaseButton
                size="sm"
                :disabled="loading"
                @click="$refs.drawer.open()"
              >
                <i class="fas fa-file-export" />
                Exporter
              </BaseButton>
            </b-col>
          </b-row>
        </template>

        <template #drawer>
          <BaseDrawer ref="drawer" :loading="loading">
            <template #default>
              <b-card no-body>
                <b-card-header>
                  <b-row>
                    <b-col cols="8">
                      <h2 class="mb-0">
                        <h2>Filtrer les résultats de l'exportation</h2>
                      </h2>
                    </b-col>
                  </b-row>
                </b-card-header>
                <b-card-body>
                  <b-row>
                    <b-col md="12">
                      <b-card no-body>
                        <b-card-header>
                          <h3 class="mb-0">Catégorie principale</h3>
                        </b-card-header>
                        <b-card-body>
                          <b-row class="form-group mt-4">
                            <b-col md="6">
                              <TreeselectInput
                                v-if="treeselectCategories"
                                v-model="exportFilters.categories"
                                form-group-classes="mb-0"
                                label="Filtrer par catégories"
                                :multiple="true"
                                placeholder="Sélectionnez les catégories"
                                :options="treeselectCategories"
                              />
                            </b-col>
                          </b-row>
                        </b-card-body> </b-card
                    ></b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </template>
            <template #footer="{ cancel, close }">
              <BaseButton ref="closeButton" @click="cancel">Annuler</BaseButton>
              <BaseButton
                :disabled="loading"
                type="primary"
                @click="handleExport(close)"
              >
                <i class="fa fa-download" />
                Exporter
              </BaseButton>
            </template>
          </BaseDrawer>
        </template>

        <el-table-column
          prop="requestDate"
          sortable
          label="Date de requête"
          width="225px"
        >
          <template slot-scope="scope">
            {{ scope.row.requestDate | dateFormatDefaultWithTime }}
          </template>
        </el-table-column>

        <el-table-column prop="status" sortable label="Statut" width="150px">
          <template slot-scope="scope">
            {{ $t(`exports.statuses.${scope.row.status}`) }}
          </template>
        </el-table-column>

        <el-table-column
          prop="completeDate"
          sortable
          label="Complété le"
          width="225px"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.completeDate">
              {{ scope.row.completeDate | dateFormatDefaultWithTime }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="account.firstName"
          sortable
          label="Demandé par"
          width="175px"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.account">
              {{ scope.row.account.firstName }} {{ scope.row.account.lastName }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="Filtres" width="200px">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.query"
              placement="top-start"
              trigger="hover"
            >
              <code>{{ scope.row.query }}</code>
              <code slot="reference">
                {{ scope.row.query }}
              </code>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column label="Erreur" min-width="200px">
          <template slot-scope="scope">
            {{ scope.row.exception }}
          </template>
        </el-table-column>

        <el-table-column align="right" width="175px">
          <template slot-scope="scope" class="table-actions">
            <DownloadFileButton
              v-if="scope.row.status === 'COMPLETED'"
              action="utils/getExportFile"
              :filename="scope.row.fileName"
              :loading="loading"
              @loading="loading = $event"
            />
          </template>
        </el-table-column>
      </BaseTableSearch>
    </b-container>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import {
  BaseHeader,
  BaseButton,
  RouteBreadcrumb,
} from '@coop-zone/coop-zone-argon'

import TreeselectInput from '@/components/Inputs/TreeselectInput'
import BaseTableSearch from '@/components/BaseTableSearch'
import BaseDrawer from '@/components/BaseDrawer'
import DownloadFileButton from '@/components/DownloadFileButton'
import ErrorHandlerMixin from '@/mixins/errorHandler.mixin'

export default {
  components: {
    BaseHeader,
    BaseTableSearch,
    BaseDrawer,
    BaseButton,
    DownloadFileButton,
    RouteBreadcrumb,
    TreeselectInput,
  },
  mixins: [ErrorHandlerMixin],
  data() {
    return {
      loading: false,
      refreshTimeout: null,
      exports: [],
      exportFilters: {
        categories: null,
      },
    }
  },
  computed: {
    ...mapState('utils', ['treeselectCategories']),
    formattedFilters() {
      const filters = {}
      Object.keys(this.exportFilters).forEach((key) => {
        if (this.exportFilters[key]) {
          if (
            Array.isArray(this.exportFilters[key]) === false ||
            this.exportFilters[key].length > 0
          ) {
            filters[key] = this.exportFilters[key]
          }
        }
      })
      return filters
    },
  },
  async created() {
    this.loading = true
    await this.fetch()
    this.loading = false

    this.refreshTimeout = setInterval(async () => {
      await this.fetch()
    }, 15000)
    this.$store.dispatch('utils/getTreeselectCategories')
  },
  beforeDestroy() {
    clearInterval(this.refreshTimeout)
  },
  methods: {
    async fetch() {
      this.exports = await this.$store.dispatch(
        'utils/getExportQueue',
        'product'
      )
    },

    async handleExport(drawerCloseCb) {
      await this.export()
      drawerCloseCb()
    },
    async export() {
      try {
        this.loading = true
        this.exports.unshift(
          await this.$store.dispatch('utils/createExportation', {
            type: 'product',
            query: this.formattedFilters,
          })
        )

        this.$notify({
          message: 'La requête a bien été enregistrée',
          timeout: 5000,
          icon: 'ni ni-check-bold',
          type: 'success',
        })

        this.loading = false
      } catch (error) {
        this.loading = false
        this.handleError(error)
      }
    },
  },
}
</script>
